import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { ValidationStatus, api, handleApiRequestSuccessData, handleRequestError, handleServerCoverageListItemData } from '@jove-frontend/uikit';
import { isArray, uniqueId } from 'lodash';
import qs from 'qs';
export var getAllValidations = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var limit, offset, sortOrder, sortColumn, action_required, candidate_name, organization, assignee, status, params, res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            limit = _ref.limit, offset = _ref.offset, sortOrder = _ref.sortOrder, sortColumn = _ref.sortColumn, action_required = _ref.action_required, candidate_name = _ref.candidate_name, organization = _ref.organization, assignee = _ref.assignee, status = _ref.status;
            _context.prev = 1;
            params = new URLSearchParams();
            params.append('limit', limit.toString());
            params.append('offset', offset.toString());
            params.append('sort_column', sortColumn);
            params.append('sort_order', sortOrder);
            action_required === null || action_required === void 0 ? void 0 : action_required.filter(function (i) {
              return i.checked;
            }).forEach(function (i) {
              return params.append('action_required', i.value === 'Yes' ? 'true' : 'false');
            });
            organization === null || organization === void 0 ? void 0 : organization.filter(function (i) {
              return i.checked;
            }).forEach(function (i) {
              return params.append('organization_name', i.value);
            });
            assignee === null || assignee === void 0 ? void 0 : assignee.filter(function (i) {
              return i.checked;
            }).forEach(function (i) {
              return params.append('assignee_name', i.value);
            });
            status === null || status === void 0 ? void 0 : status.filter(function (i) {
              return i.checked;
            }).forEach(function (i) {
              return params.append('status', i.value);
            });

            if (candidate_name) {
              params.append('candidate_name', candidate_name);
            }

            _context.next = 14;
            return api.get('/validations', {
              params: params
            });

          case 14:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](1);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch validations because: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 18]]);
  }));

  return function getAllValidations(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export var apiCreateValidation = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload, token) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/validations", payload, {
              params: {
                token: token
              }
            });

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data.data.validation]);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to create validation: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function apiCreateValidation(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();
export var getValidation = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(validationId, token) {
    var res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;

            if (validationId) {
              _context3.next = 3;
              break;
            }

            throw new Error("Invalid id: ".concat(validationId));

          case 3:
            _context3.next = 5;
            return api.get("/validations/".concat(validationId), {
              params: {
                token: token
              }
            });

          case 5:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data.data]);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to fetch validation: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 9]]);
  }));

  return function getValidation(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var apiGetValidationRequirements = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, token, extraParams) {
    var res, _err$response4, _err$response4$data, _err$response4$data$d, _err$response4$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;

            if (id) {
              _context4.next = 3;
              break;
            }

            throw new Error("Invalid id: ".concat(id));

          case 3:
            _context4.next = 5;
            return api.get('/validation_requirements', {
              params: _objectSpread({
                validation_id: id,
                sort_column: 'created_at',
                sort_order: 'DESC',
                token: token
              }, extraParams)
            });

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data.data]);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            message = (_err$response4 = _context4.t0.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : (_err$response4$data$d = _err$response4$data.detail) === null || _err$response4$data$d === void 0 ? void 0 : (_err$response4$data$d2 = _err$response4$data$d[0]) === null || _err$response4$data$d2 === void 0 ? void 0 : _err$response4$data$d2.msg;
            console.error("Failed to fetch validation requirements: ".concat(message));
            return _context4.abrupt("return", [null, _context4.t0]);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function apiGetValidationRequirements(_x6, _x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();
export var apiUpdateValidation = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref6, token) {
    var validationId, payload, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            validationId = _ref6.validationId, payload = _ref6.payload;
            _context5.prev = 1;

            if (validationId) {
              _context5.next = 4;
              break;
            }

            throw new Error('No validation id was provided');

          case 4:
            _context5.next = 6;
            return api.patch("/validations/".concat(validationId), payload, {
              params: {
                token: token
              }
            });

          case 6:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data.data.validation]);

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", handleRequestError(_context5.t0));

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 10]]);
  }));

  return function apiUpdateValidation(_x9, _x10) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiGetCovers = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var res, _err$response5, _err$response5$data, _err$response5$data$d, _err$response5$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.get("/covers", {
              params: {
                sort_column: 'name',
                sort_order: 'ASC'
              }
            });

          case 3:
            res = _context6.sent;

            if (isArray(res.data.data)) {
              res.data.data.forEach(function (item) {
                var _item$cover, _item$cover2, _item$cover3;

                item.cover = _objectSpread(_objectSpread({}, item.cover), {}, {
                  value: (_item$cover = item.cover) === null || _item$cover === void 0 ? void 0 : _item$cover.slug,
                  label: (_item$cover2 = item.cover) === null || _item$cover2 === void 0 ? void 0 : _item$cover2.name,
                  cover_name: (_item$cover3 = item.cover) === null || _item$cover3 === void 0 ? void 0 : _item$cover3.name
                });
              });
            }

            return _context6.abrupt("return", [res.data.data]);

          case 8:
            _context6.prev = 8;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response5 = _context6.t0.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$data = _err$response5.data) === null || _err$response5$data === void 0 ? void 0 : (_err$response5$data$d = _err$response5$data.detail) === null || _err$response5$data$d === void 0 ? void 0 : (_err$response5$data$d2 = _err$response5$data$d[0]) === null || _err$response5$data$d2 === void 0 ? void 0 : _err$response5$data$d2.msg;
            console.error("Failed to fetch covers : ".concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 8]]);
  }));

  return function apiGetCovers() {
    return _ref8.apply(this, arguments);
  };
}();
export var apiUpdateValidationRequirement = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(validationRequirementId, payload, token) {
    var res, _err$response6, _err$response6$data, _err$response6$data$d, _err$response6$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;

            if (validationRequirementId) {
              _context7.next = 3;
              break;
            }

            throw new Error('No validation requirement id was provided');

          case 3:
            _context7.next = 5;
            return api.patch("/validation_requirements/".concat(validationRequirementId), payload, {
              params: {
                token: token
              }
            });

          case 5:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data.data.validation_requirement]);

          case 9:
            _context7.prev = 9;
            _context7.t0 = _context7["catch"](0);
            message = (_err$response6 = _context7.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : (_err$response6$data$d = _err$response6$data.detail) === null || _err$response6$data$d === void 0 ? void 0 : (_err$response6$data$d2 = _err$response6$data$d[0]) === null || _err$response6$data$d2 === void 0 ? void 0 : _err$response6$data$d2.msg;
            console.error("Failed to update validation requirement ".concat(validationRequirementId, " : ").concat(message));
            return _context7.abrupt("return", [null, _context7.t0]);

          case 14:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 9]]);
  }));

  return function apiUpdateValidationRequirement(_x11, _x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiResetValidationRequirements = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(validationId, payload, token) {
    var _payload$exclude_stat, params, res, _err$response7, _err$response7$data, _err$response7$data$d, _err$response7$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;

            if (validationId) {
              _context8.next = 3;
              break;
            }

            throw new Error('No validation id was provided');

          case 3:
            params = new URLSearchParams();
            (_payload$exclude_stat = payload.exclude_status) === null || _payload$exclude_stat === void 0 ? void 0 : _payload$exclude_stat.forEach(function (status) {
              return params.append('exclude_status', status);
            });

            if (token) {
              params.append('token', token);
            }

            _context8.next = 8;
            return api.get("/validations/".concat(validationId, "/reset_validation_requirements"), {
              params: params
            });

          case 8:
            res = _context8.sent;
            return _context8.abrupt("return", [res.data]);

          case 12:
            _context8.prev = 12;
            _context8.t0 = _context8["catch"](0);
            message = (_err$response7 = _context8.t0.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$data = _err$response7.data) === null || _err$response7$data === void 0 ? void 0 : (_err$response7$data$d = _err$response7$data.detail) === null || _err$response7$data$d === void 0 ? void 0 : (_err$response7$data$d2 = _err$response7$data$d[0]) === null || _err$response7$data$d2 === void 0 ? void 0 : _err$response7$data$d2.msg;
            console.error("Failed to update validation ".concat(validationId, " : ").concat(message));
            return _context8.abrupt("return", [null, _context8.t0]);

          case 17:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 12]]);
  }));

  return function apiResetValidationRequirements(_x14, _x15, _x16) {
    return _ref10.apply(this, arguments);
  };
}();
export var apiQueryValidationCountryRequirements = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(payload) {
    var res, _listPriority, listPriority;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.get("/msp/validations/".concat(payload.validationId, "/requirements?").concat(qs.stringify(payload)));

          case 3:
            res = _context9.sent;

            if (res !== null && res !== void 0 && res.data) {
              res.data.msp_reqs = (res.data.msp_reqs || []).map(function (item) {
                var _item$validation_reqs, _item$validation_reqs2;

                item.validation_reqs = (item.validation_reqs || []).map(function (aItem) {
                  return _objectSpread(_objectSpread({}, aItem), aItem.validation_requirement);
                });
                item.validation_documents = (item.validation_documents || []).map(function (aItem) {
                  return _objectSpread(_objectSpread({}, aItem), aItem.validation_document);
                });
                var isClientLevelRequired = !!((_item$validation_reqs = item.validation_reqs) !== null && _item$validation_reqs !== void 0 && (_item$validation_reqs2 = _item$validation_reqs[0]) !== null && _item$validation_reqs2 !== void 0 && _item$validation_reqs2.client_level_required); // Company tabs

                var companyValidationRequirementList = item.company_validation_requirement || [];

                if (!isClientLevelRequired) {
                  var allCompanyItem = {
                    company_name: 'All companies',
                    company_id: "all-".concat(uniqueId()),
                    validation_requirement: item.all_companies || []
                  };
                  companyValidationRequirementList.unshift(allCompanyItem);
                }

                item.company_validation_requirement = companyValidationRequirementList.map(function (aItem) {
                  var requirementList = (aItem.validation_requirement || []).map(function (cItem) {
                    return _objectSpread(_objectSpread({}, cItem), cItem.validation_requirement);
                  });
                  return _objectSpread(_objectSpread({}, aItem), {}, {
                    validation_requirement: requirementList
                  });
                });
                return item;
              }); // Sort by status

              listPriority = (_listPriority = {}, _defineProperty(_listPriority, ValidationStatus.NOT_STARTED, 1), _defineProperty(_listPriority, ValidationStatus.FAIL, 2), _defineProperty(_listPriority, ValidationStatus.IN_PROGRESS, 3), _defineProperty(_listPriority, ValidationStatus.PENDING, 4), _defineProperty(_listPriority, ValidationStatus.SUCCESS, 5), _listPriority);
              res.data.msp_reqs.sort(function (a, b) {
                return (listPriority[a.status] || 0) - (listPriority[b.status] || 0);
              });
              res.data.validation_reqs = (res.data.validation_reqs || []).map(function (item) {
                var _item$validation_requ, _item$validation_requ2, _item$validation_requ3, _item$validation_requ4;

                return _objectSpread(_objectSpread(_objectSpread({}, item), item.validation_requirement), {}, {
                  agent_verified_data: handleServerCoverageListItemData((_item$validation_requ = item.validation_requirement) === null || _item$validation_requ === void 0 ? void 0 : _item$validation_requ.agent_verified_data),
                  displayed_data: handleServerCoverageListItemData((_item$validation_requ2 = item.validation_requirement) === null || _item$validation_requ2 === void 0 ? void 0 : _item$validation_requ2.displayed_data),
                  extracted_data: handleServerCoverageListItemData((_item$validation_requ3 = item.validation_requirement) === null || _item$validation_requ3 === void 0 ? void 0 : _item$validation_requ3.extracted_data),
                  user_overwritten_data: handleServerCoverageListItemData((_item$validation_requ4 = item.validation_requirement) === null || _item$validation_requ4 === void 0 ? void 0 : _item$validation_requ4.user_overwritten_data)
                });
              });
              res.data.contract_reqs = (res.data.contract_reqs || []).map(function (item) {
                var contract_requirement = item.contract_requirement,
                    area = item.area,
                    organization_subsidiary = item.organization_subsidiary,
                    policyholder = item.policyholder,
                    supplier_company = item.supplier_company;

                var temp = _objectSpread(_objectSpread(_objectSpread({}, item), contract_requirement), {}, {
                  data: _objectSpread(_objectSpread({}, handleServerCoverageListItemData(contract_requirement === null || contract_requirement === void 0 ? void 0 : contract_requirement.data)), {}, {
                    applicable_geographic_area: {
                      area_type: (area === null || area === void 0 ? void 0 : area.area_type) || '',
                      countries: (area === null || area === void 0 ? void 0 : area.countries) || []
                    },
                    organization_subsidiary: organization_subsidiary,
                    policyholder: isArray(policyholder) ? policyholder.join(', ') : '',
                    applicable_companies: supplier_company
                  })
                });

                return temp;
              });
              res.data.validation_documents = (res.data.validation_documents || []).map(function (item) {
                return _objectSpread(_objectSpread({}, item), item.validation_document);
              });
            }

            return _context9.abrupt("return", [res.data]);

          case 8:
            _context9.prev = 8;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", handleRequestError(payload));

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 8]]);
  }));

  return function apiQueryValidationCountryRequirements(_x17) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * Upload file, GPT parses insurance file information
 */

export var extractInsuranceFiles = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.post("/validation_documents/extract", payload.formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              params: {
                token: payload.token
              }
            });

          case 3:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", handleRequestError(_context10.t0));

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));

  return function extractInsuranceFiles(_x18) {
    return _ref12.apply(this, arguments);
  };
}();
export var queryValidationAllValidDocuments = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payload) {
    var _res$data, res;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.get("/validation_documents/extractions/".concat(payload === null || payload === void 0 ? void 0 : payload.validationId));

          case 3:
            res = _context11.sent;

            if (isArray((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data = res.data.data.map(function (item) {
                return _objectSpread(_objectSpread(_objectSpread({}, item), item.validation_document), {}, {
                  value: item.document_id,
                  label: item.name
                });
              });
            }

            return _context11.abrupt("return", [res.data]);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](0);
            return _context11.abrupt("return", handleRequestError(_context11.t0));

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 8]]);
  }));

  return function queryValidationAllValidDocuments(_x19) {
    return _ref13.apply(this, arguments);
  };
}();
export var apiCreateSupplierSubsidiary = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api.post("/msp/supplier/subsidiary?".concat(qs.stringify({
              token: payload === null || payload === void 0 ? void 0 : payload.token
            })), payload);

          case 3:
            res = _context12.sent;
            return _context12.abrupt("return", [res.data]);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            return _context12.abrupt("return", handleRequestError(_context12.t0, payload));

          case 10:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));

  return function apiCreateSupplierSubsidiary(_x20) {
    return _ref14.apply(this, arguments);
  };
}();
export var apiUpdateSupplierSubsidiary = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.patch("/msp/supplier/subsidiary/".concat(payload.subsidiary_id, "?").concat(qs.stringify({
              token: payload === null || payload === void 0 ? void 0 : payload.token
            })), payload);

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", [res.data]);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            return _context13.abrupt("return", handleRequestError(_context13.t0, payload));

          case 10:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function apiUpdateSupplierSubsidiary(_x21) {
    return _ref15.apply(this, arguments);
  };
}();
export var apiDeleteSupplierSubsidiary = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return api["delete"]("/msp/supplier/subsidiary/".concat(payload.subsidiary_id, "?").concat(qs.stringify(payload)));

          case 3:
            res = _context14.sent;
            return _context14.abrupt("return", [res.data]);

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            return _context14.abrupt("return", handleRequestError(_context14.t0, payload));

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));

  return function apiDeleteSupplierSubsidiary(_x22) {
    return _ref16.apply(this, arguments);
  };
}();
export var apiGetValidationRequirementDetailInfo = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return api.get("/validation_requirements/".concat(payload === null || payload === void 0 ? void 0 : payload.validationRequirementId));

          case 3:
            res = _context15.sent;
            return _context15.abrupt("return", [res.data]);

          case 7:
            _context15.prev = 7;
            _context15.t0 = _context15["catch"](0);
            return _context15.abrupt("return", handleRequestError(_context15.t0));

          case 10:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 7]]);
  }));

  return function apiGetValidationRequirementDetailInfo(_x23) {
    return _ref17.apply(this, arguments);
  };
}();
export var apiGetValidationDocumentDetailInfoList = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(payload) {
    var querys, res;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            querys = _objectSpread({}, payload);
            delete querys.validationId;
            _context16.next = 5;
            return api.get("/validation_documents/validation_requirement/".concat(payload === null || payload === void 0 ? void 0 : payload.validationId, "?").concat(qs.stringify(querys)));

          case 5:
            res = _context16.sent;
            return _context16.abrupt("return", [res.data]);

          case 9:
            _context16.prev = 9;
            _context16.t0 = _context16["catch"](0);
            return _context16.abrupt("return", handleRequestError(_context16.t0));

          case 12:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 9]]);
  }));

  return function apiGetValidationDocumentDetailInfoList(_x24) {
    return _ref18.apply(this, arguments);
  };
}();
export var apiGetValidationOriginDataBeforeUploadFile = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return api.get("/validation_documents/initial_requirements/".concat(payload === null || payload === void 0 ? void 0 : payload.validationId));

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", [res.data]);

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            return _context17.abrupt("return", handleRequestError(_context17.t0));

          case 10:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));

  return function apiGetValidationOriginDataBeforeUploadFile(_x25) {
    return _ref19.apply(this, arguments);
  };
}();
export var apiQuerySupplierSubsidiary = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api.get("/msp/supplier/subsidiary/all?".concat(qs.stringify(payload)));

          case 3:
            res = _context18.sent;
            return _context18.abrupt("return", [res.data]);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", handleRequestError(_context18.t0, payload));

          case 10:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));

  return function apiQuerySupplierSubsidiary(_x26) {
    return _ref20.apply(this, arguments);
  };
}();
export var apiUpdateValidationDocumentAgentInputInfo = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return api.patch("/validation_documents/extraction_agent_input/".concat(payload.document_id), payload);

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", [res.data]);

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            return _context19.abrupt("return", handleRequestError(_context19.t0, payload));

          case 10:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));

  return function apiUpdateValidationDocumentAgentInputInfo(_x27) {
    return _ref21.apply(this, arguments);
  };
}();
export var apiGetCompanies = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(payload) {
    var res, formatedData;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return api.get("/public/companies/organization/".concat(payload.organizationId, "?candidate_type=candidate"));

          case 2:
            res = _context20.sent;
            formatedData = res.data.companies.map(function (i) {
              return _objectSpread(_objectSpread({}, i), {}, {
                company: {
                  id: i.company.id,
                  name: i.company.name,
                  industry: i.company_industry
                }
              });
            });
            return _context20.abrupt("return", [formatedData]);

          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function apiGetCompanies(_x28) {
    return _ref22.apply(this, arguments);
  };
}();
export var apiGetGenericRegions = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return api.get("/public/organization_region/organization/".concat(payload.organizationId, "?candidate_type=candidate"));

          case 2:
            res = _context21.sent;
            return _context21.abrupt("return", [res.data.data]);

          case 4:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function apiGetGenericRegions(_x29) {
    return _ref23.apply(this, arguments);
  };
}();
export var apiGetValidationInfoWithNoAuth = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            _context22.next = 3;
            return api.get("/public/validations/".concat(payload === null || payload === void 0 ? void 0 : payload.validationId));

          case 3:
            res = _context22.sent;
            return _context22.abrupt("return", [res.data]);

          case 7:
            _context22.prev = 7;
            _context22.t0 = _context22["catch"](0);
            return _context22.abrupt("return", handleRequestError(_context22.t0, payload));

          case 10:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[0, 7]]);
  }));

  return function apiGetValidationInfoWithNoAuth(_x30) {
    return _ref24.apply(this, arguments);
  };
}();
export var apiGetQuoteAssumptionDataByValidationId = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.prev = 0;
            _context23.next = 3;
            return api.post("/switch_to_jove/create-from-validation/".concat(payload === null || payload === void 0 ? void 0 : payload.validationId));

          case 3:
            res = _context23.sent;
            handleApiRequestSuccessData(res);
            return _context23.abrupt("return", [res.data]);

          case 8:
            _context23.prev = 8;
            _context23.t0 = _context23["catch"](0);
            return _context23.abrupt("return", handleRequestError(_context23.t0, payload));

          case 11:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, null, [[0, 8]]);
  }));

  return function apiGetQuoteAssumptionDataByValidationId(_x31) {
    return _ref25.apply(this, arguments);
  };
}();
export var apiSendWhatsappMessageWithValidationInfo = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;
            _context24.next = 3;
            return api.post("/validations/batch_send_whatsapp", payload);

          case 3:
            res = _context24.sent;
            handleApiRequestSuccessData(res);
            return _context24.abrupt("return", [res.data]);

          case 8:
            _context24.prev = 8;
            _context24.t0 = _context24["catch"](0);
            return _context24.abrupt("return", handleRequestError(_context24.t0, payload));

          case 11:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, null, [[0, 8]]);
  }));

  return function apiSendWhatsappMessageWithValidationInfo(_x32) {
    return _ref26.apply(this, arguments);
  };
}();